import { HelpService } from './../../help/help.service';
import { Title } from '@angular/platform-browser';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent, DxRangeSelectorComponent, DxSelectBoxComponent, DxDataGridComponent } from 'devextreme-angular';
import { GlobalConstants } from 'src/app/common/global-constants';
import { HtmlControlType } from 'src/app/enums/htmlControlType';
import { FiltersOutput, FilterInput, FilterOutput, FilterValue, ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { SelectStatementCaption, ForecastOverviewTableData, ForecastOverviewPram, ForecastAlterGroupValue, ForecastChartCaption, SettingValue } from 'src/app/models/forecast/fc-overview-models';
import { TopdownAddAdjustmentSelection, TopdownAdjustmentParamNew } from 'src/app/models/forecast/topdown-adjustment.model';
import { UtilsService } from 'src/app/services/utils.service';
import { DropdowndSelectedValues, DevTooltipCustComponent } from 'src/app/widgets';

import { ForecastService } from '../forecast.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { ActivatedRoute } from '@angular/router';
import { TaskService } from '../../task/task.service';
import { TaskDataFilter } from '../../stock/stock.service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { NotificationService } from 'src/app/services/notification.service';
import { ManualInputService } from '../../manual-input/manual-input.service';
import { FileExportService } from 'src/app/common/file-export-service';
import { SettingsService } from '../../settings/settings.service';
import { NextPreValue } from 'src/app/models/forecast/NextPrevious';
import { Subject } from 'rxjs';
import { ConsoleService } from 'src/app/services/console.service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { TopdownAdjustmentCommonComponent } from 'src/app/widgets/topdown-adjustment-common/topdown-adjustment-common.component';


@Component({
    selector: 'app-overview-new',
    templateUrl: './overview-new.component.html',
    styleUrls: ['./overview-new.component.scss'],
    standalone: false
})
export class OverviewNewComponent implements OnInit {

	//Default data settings
	//Filter Variable initialization
	filterOptions: FiltersOutput;
	nxtPreFilterOptions: FiltersOutput;

	filterList: FilterInput[] = [];
	htmlControlType = HtmlControlType;
	resetFiltersItems: string[] = [];

	//chart value range
	visualRange: any = {};

	//default data initialization
	forecastDevelopmentChartSource: any = [];
	yearOnYearChartDataSource: any = [];
	seasonalityChartDataSource: any = [];

	CustSelectionOption: any = [];
	OverviewQuantity: any = [];
	datata: any = { value: 'selectedRawItem' };

	//Forecast Seasonality Grph enable disable contain
	EnableDisableForecastSeasonalityActual1 = true;
	EnableDisableForecastSeasonalityActual2 = true;
	EnableDisableForecastSeasonalityActual3 = true;
	EnableDisableForecastSeasonalityForecastFinal3 = true;
	EnableDisableForecastSeasonalityMin = true;
	EnableDisableForecastSeasonalityMax = true;

	//default data initialization
	forecastTagboxData: any = [];

	//default parameters
	action = 'Filter';
	Action = 'Data';
	Unit = 'Quantity';
	settingGroupId = 12;
	UnitOfMeasure = 'BaseUnit';
	period: string = "";
	currentlySelectedFilters: FilterInput[] = [];
	lastSelectedFilter: FilterInput;
	dataFilter: BookmarkData;
	pageName: string = "ForecastOverview";

	// Overview Table
	tableColumnsDataSource: SelectStatementCaption[] = [];
	tableValuesDataSource: any[] = [];
	selectedFcTableRecords: ForecastOverviewTableData[] = [];
	changedFcTableRecords: ForecastOverviewTableData[] = [];
	chartAlterGroup: ForecastChartCaption[] = [];
	alterGroupData: ForecastAlterGroupValue[] = [];
	settingValueData: SettingValue[] = [];
	forecastChartCaption: ForecastChartCaption[];
	issueResponsesDataSource: string[] = [];
	showInfoPopup = false;
	infoPopupMessage = '';
	unsavedChanges = false;
	fitTableToPage = false;
	anyActiveFilters = false;
	infPopupTitle = '';
	alterGroupTitle = "";
	alterGrouphideShow = false;
	titleOverviewTitle = "Monthly";
	startChartValue = { startValue: 0 };
	changingValue: Subject<boolean> = new Subject();
	topDownVisibility = true;

	gridMinWidthSetting = 0;

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("forecastDevelopmentChart", { static: false }) dxForecastDevelopmentChart: DxChartComponent;
	@ViewChild("seasonalityChart", { static: false }) dxSeasonalityChart: DxChartComponent;
	@ViewChild("yearOnYearChart", { static: false }) dxYearOnYearChart: DxChartComponent;
	@ViewChild("forecastDevelopmentRangSelct", { static: false }) forecastDevelopmentRangSelct: DxRangeSelectorComponent;
	@ViewChild("SelectBoxOverviewQuantitySelct", { static: false }) SelectBoxOverviewQuantitySelct: DxSelectBoxComponent;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;
	@ViewChild("alterGroupChart", { static: false }) dxAlterGroupChart: DxChartComponent;

	// constructor for loading services
	constructor(
		private taskService: TaskService,
		private forecastService: ForecastService,
		private titleService: Title,
		private settingsService: SettingsService,
		private helpService: HelpService,
		private shareDataService: ShareDataService,
		private route: ActivatedRoute,
		private notificationService: NotificationService,
		private fileExportService: FileExportService,
		private manualInputService: ManualInputService,
		private tableParamService: TableParameterService,

		public consoleService: ConsoleService
	) {
		this.shareDataService.CleanData();
	}

	ngAfterViewInit(): void {
	}

	@ViewChild('TopDownComp', { static: false }) TopDownComp: TopdownAdjustmentCommonComponent;

	taskFilterData: TaskDataFilter[];
	IsTaskLoad = false;
	IsFilterLoaded = false;
	ngOnInit() {
		this.titleService.setTitle("Overview");
		this.route.paramMap.subscribe(
			params => {
				
				const value = this.route.snapshot.queryParamMap.get("taskid");
				if (value) {
					//default load with parameters
					this.filterOptions = new FiltersOutput();
					this.filterOptions.action = this.action;
					this.filterOptions.settingGroupId = this.settingGroupId;
					this.filterOptions.filters = [];
					//loading filter data
					this.taskService.SelectTaskFilterValues(value).subscribe(data => {
						this.taskFilterData = data;
						this.taskFilterData.forEach(element => {
							let filteItem: FilterOutput = new FilterOutput();
							filteItem.fieldValue = element.settingValue;
							filteItem.settingId = element.settingId;
							this.filterOptions.filters.push(filteItem);
						});
						this.IsTaskLoad = true;
						this.fillSharedItem();
						this.getFiltersData();
						this.getData('pageload');
					}, err => { });
				}
				else {

					this.dataFilter = new BookmarkData();
					this.dataFilter.BookmarkId = 0;
					this.dataFilter.name = "DefBokmk";
					this.dataFilter.pageName = this.pageName;
					this.loadBookMarkFilter();
				}

			});
		this.GetSettingsData();
		this.WebSettingsPivot();
		this.SettingsGroupByName();

		this.settingsService.getGeneralSettings().subscribe(res => {
			let colWidth = res.settings.find(x => x.name == 'Grid Minimum Column Width');
			if (colWidth) {
				this.gridMinWidthSetting = +colWidth.value;
			}
		});
	}
	SettingDecimal: any;
	SettingsGroupByName() {
		this.settingsService.SettingsGroupByName("FcDeepDive", "ForecastCurrencyField").subscribe(result => {
			this.SettingDecimal = result.table;
		});
	}

	loadGridState = () => {
		if (localStorage.getItem("eso-overview-storage") && this.dataGrid) {
			const state = JSON.parse(localStorage.getItem("eso-overview-storage"));
			this.dataGrid.instance.state(state);
		}
	}

	saveGridState = (newState) => {
		const state = this.dataGrid.instance.state();
		// Saves the state in the local storage
		localStorage.setItem("eso-overview-storage", JSON.stringify(state));
	}

	loadBookMarkFilterClick(data) {
		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.filterOptions.filters = [];
			this.clearSelectedItem();
			this.filterList.map(item => item.selectedValues = []);
			this.resetFiltersItems = [];
			this.currentlySelectedFilters = [];

			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = "Bokmk";
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	ChartSettings: any;
	loadBookMarkFilter() {
		let filterData = Object.assign({}, this.dataFilter);
		filterData.name = "BokmkN";
		this.ChartSettings = null;
		this.taskService.LoadBookmarkData(filterData).subscribe(RData => {
			if (RData != null && RData.table != null && RData.table.length > 0) {

				if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != "") {
					
					this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
				}
				this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(data => {
					this.taskFilterData = data;
					//default load with parameters
					this.filterOptions = new FiltersOutput();
					this.filterOptions.action = this.action;
					this.filterOptions.settingGroupId = this.settingGroupId;
					this.filterOptions.filters = [];
					this.taskFilterData.forEach(element => {
						let filteItem: FilterOutput = new FilterOutput();
						filteItem.fieldValue = element.settingValue;
						filteItem.settingId = element.settingId;
						this.filterOptions.filters.push(filteItem);
					});

					this.IsTaskLoad = true;
					this.fillSharedItem();
					this.getFiltersData();
					this.getData('pageload');

				}, err => {
				});

			}
			else {

				this.initFilterOptions();
			}
		}, err => {
		});
	}

	LoadChartSeries() {
		if (this.ChartSettings != null) {

			if (this.ChartSettings.ForecastDevelopmentChart != null && this.ChartSettings.ForecastDevelopmentChart.length > 0) {
				if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
					&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
						this.ChartSettings.ForecastDevelopmentChart.forEach(itemchrt => {
							if (this.dxForecastDevelopmentChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxForecastDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.YearOnYearChart != null && this.ChartSettings.YearOnYearChart.length > 0) {
				if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null
					&& Array.isArray(this.dxYearOnYearChart.series) && this.dxYearOnYearChart.series.length > 0) {
					for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
						this.ChartSettings.YearOnYearChart.forEach(itemchrt => {
							if (this.dxYearOnYearChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxYearOnYearChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxYearOnYearChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxYearOnYearChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.SeasonalityChart != null && this.ChartSettings.SeasonalityChart.length > 0) {
				if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null
					&& Array.isArray(this.dxSeasonalityChart.series) && this.dxSeasonalityChart.series.length > 0) {
					for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
						this.ChartSettings.SeasonalityChart.forEach(itemchrt => {
							if (this.dxSeasonalityChart.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxSeasonalityChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxSeasonalityChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}

		}
	}

	private initFilterOptions() {

		//default load with parameters
		this.filterOptions = new FiltersOutput();
		this.filterOptions.action = this.action;
		this.filterOptions.settingGroupId = this.settingGroupId;
		this.filterOptions.filters = [];
		//loading filter data

		this.getFiltersData();
		this.getData('pageload');

	}

	private LoadTagBoxData() {
		this.forecastService.GetTagSelectionOption("get-overviewfilter", "").subscribe(data => {
			this.forecastTagboxData = data[0];
		}, err => {
			console.log(err)
		});

	}

	//load filter data method
	IsFilterLoadedNxtPRe = false;
	private getFiltersData() {
		let $this = this;
		this.ExportToExcelFilters = this.filterMappingService.mapFilterOutputToFilterValue(this.filterOptions.filters);
		this.forecastService.GetFcFiltersNew(this.settingGroupId, this.filterOptions.filters).subscribe(res => {
			//convert received data to table structure for drop down
			res.forEach(item => {
				if (item.values) {
					item.values = item.values.map(all => ({ all }));
					if (item.displayName === 'UnitOfMeasure' && item.values.length > 0) {
						item.selectedValues = [item.values[0].all];
					}
				}
			});
			$this.filterList = res.filter(item => item.isVisible);

			for (let index = 0; index < this.filterList.length; index++) {
				if (this.filterList[index]) {
					let data = this.currentlySelectedFilters.filter(x => x.selectionId == this.filterList[index].selectionId);
					if (data && data.length > 0) {
						this.filterList[index].selectedValues = data[0].selectedValues;
						this.lastSelectedFilter = null;
					}
				}
			}

			if (this.IsTaskLoad) {
				this.IsTaskLoad = false;
				$this.filterList.forEach(element => {
					let Data = this.taskFilterData.filter(x => x.settingId == element.selectionId);
					if (Data != null && Data.length > 0) {
						let arr = Data.map(function (item) {
							return item['settingValue'];
						});
						element.selectedValues = arr;
					}
				});
			}
			this.IsFilterLoaded = true;
			this.IsFilterLoadedNxtPRe = true;
		}, err => {
			console.log(err);
			this.IsFilterLoaded = false;
			this.IsFilterLoadedNxtPRe = true;
		},
			() => {
			}
		);
	}

	selectedItemsChanged(event: DropdowndSelectedValues) {
		this.filterList
			.filter(item => item.selectionId === event.selectionId)
			.forEach(item => item.selectedValues = event.values);

		this.lastSelectedFilter = this.filterList.filter(item => item.selectionId === event.selectionId)[0];

	}

	//load data on each event
	private getData(action: string) {
		this.Unit = "";
		let dataObjectPram: ForecastOverviewPram = new ForecastOverviewPram();
		dataObjectPram.Action = this.Action;
		dataObjectPram.Unit = this.Unit;
		dataObjectPram.SettingGroupId = this.settingGroupId;
		dataObjectPram.UnitOfMeasure = this.UnitOfMeasure;
		dataObjectPram.filtersOptions = [];
		dataObjectPram.filterValue = []
		if (this.dxForecastDevelopmentChart) { this.dxForecastDevelopmentChart.instance.showLoadingIndicator(); }

		if (this.dxSeasonalityChart) { this.dxSeasonalityChart.instance.showLoadingIndicator(); }
		if (this.dxYearOnYearChart) { this.dxYearOnYearChart.instance.showLoadingIndicator(); }

		if (action == 'topdownLoad') {
			dataObjectPram.Action = 'topdownLoad';
			let dataFilter = this.filterList.filter(x => x.displayName == "UnitOfMeasure" || x.selectionName == "UnitOfMeasure")
			if (dataFilter != null && dataFilter.length > 0 && dataFilter[0].selectedValues.length > 0) {
				dataObjectPram.filtersOptions.push({
					settingId: dataFilter[0].selectionId,
					fieldValue: dataFilter[0].selectedValues[0]
				});
			}
			this.selectedFcTableRecords.forEach(i => {
				dataObjectPram.filtersOptions.push({ settingId: -1, fieldValue: i["ForecastObjectClientId"] });
			});
			if (this.dataGrid) { this.dataGrid.instance.beginCustomLoading('Loading...'); }
		}
		else if (action == 'loadNextPreOption') {
			if (this.nxtPreFilterOptions != null && this.nxtPreFilterOptions.filters != null && this.nxtPreFilterOptions.filters.length > 0) {
				this.nxtPreFilterOptions.filters.forEach(selElemnt => {
					dataObjectPram.filtersOptions.push({
						settingId: selElemnt.settingId,
						fieldValue: selElemnt.fieldValue
					});
				});
			}

		}
		else {
			this.filterOptions.filters.forEach(element => {
				dataObjectPram.filtersOptions.push(element);
			});
		}

		this.forecastService
			.GetOverviewDataNew(dataObjectPram).toPromise().then(data => {
				if (data != null && data.forecastChartCaption != null && data.forecastChartCaption.length > 0) {
					this.forecastChartCaption = data.forecastChartCaption;
					data.forecastChartCaption.forEach(itemCap => {
						if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
							&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
							for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {

								if (this.dxForecastDevelopmentChart.series[index].valueField != null
									&& (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()
										|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())

								) {
									this.dxForecastDevelopmentChart.series[index].name = itemCap.captionName;
								}
							}
						}

						if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null
							&& Array.isArray(this.dxSeasonalityChart.series) && this.dxSeasonalityChart.series.length > 0) {
							for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
								if (this.dxSeasonalityChart.series[index].valueField != null
									&& (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()
										|| this.dxSeasonalityChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())

								) {

									this.dxSeasonalityChart.series[index].name = itemCap.captionName;
								}
								this.dxSeasonalityChart.series[index].visible = true;
							}
						}


						if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null
							&& Array.isArray(this.dxYearOnYearChart.series) && this.dxYearOnYearChart.series.length > 0) {
							for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
								if (this.dxYearOnYearChart.series[index].valueField != null
									&& (this.dxYearOnYearChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()
										|| this.dxYearOnYearChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())

								) {
									this.dxYearOnYearChart.series[index].name = itemCap.captionName;
								}
								this.dxYearOnYearChart.series[index].visible = true;
							}
						}

						if (itemCap.fieldName.toLowerCase() == "forecastoverviewcharttitle") {
							this.titleOverviewTitle = itemCap.captionName;
						}

					});

				}

				//dynamic feild setting
				let VisibleElements = [];
				data.settingValue.forEach(settingItem => {

					if (settingItem.name.toLowerCase().includes("enabledisable")) {
						let ElementNameEnable = settingItem.name.toLowerCase();
						ElementNameEnable = ElementNameEnable.replace("enabledisable", "");
						if (settingItem.value.toLowerCase() == "no") {
							VisibleElements.push({ visible: false, showInLegend: true, SeriesName: ElementNameEnable });
						}
					}
					if (settingItem.name.toLowerCase().includes("enable")) {
						let ElementName = settingItem.name.toLowerCase();
						ElementName = ElementName.replace("forecastmainchart", "").replace("enable", "");
						if (settingItem.value.toLowerCase() == "yes") {
							VisibleElements.push({ visible: true, showInLegend: true, SeriesName: ElementName });
						}
						else if (settingItem.value.toLowerCase() == "no") {
							VisibleElements.push({ visible: false, showInLegend: false, SeriesName: ElementName });
						}
					}
				});

				if(Array.isArray(this.dxForecastDevelopmentChart.series)){
				for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
					//emable/disbale
					if (this.dxForecastDevelopmentChart.series[index].valueField != null) {

						let ElemntExists = VisibleElements.filter(x => x.SeriesName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase());

						if (ElemntExists != null && ElemntExists.length > 0) {
							if (ElemntExists.length > 1) {
								if (!ElemntExists[0].visible || !ElemntExists[1].visible) {
									this.dxForecastDevelopmentChart.series[index].visible = false;
								}
								else {
									this.dxForecastDevelopmentChart.series[index].visible = true;
								}

								if (!ElemntExists[0].showInLegend || !ElemntExists[1].showInLegend) {
									this.dxForecastDevelopmentChart.series[index].showInLegend = false;
								}
								else {
									this.dxForecastDevelopmentChart.series[index].showInLegend = true;
								}
							}
							else {
								this.dxForecastDevelopmentChart.series[index].visible = ElemntExists[0].visible;
								this.dxForecastDevelopmentChart.series[index].showInLegend = ElemntExists[0].showInLegend;
							}
						}
						else {
							if (!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("addon")
								&& !this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("actual1")
								&& !this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("actual2")
								&& !this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("actual3")) {
								this.dxForecastDevelopmentChart.series[index].visible = true;
								this.dxForecastDevelopmentChart.series[index].showInLegend = true;
							}

						}
					}

					if (data != null && data.settingValue != null && data.settingValue.length > 0) {
						data.settingValue.forEach(settingItem => {
							if (settingItem.name.toLowerCase().includes("color")) {
								let ElementName = settingItem.name.toLowerCase();
								ElementName = ElementName.replace("color", "");
								if (ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() && settingItem.value != "") {
									this.dxForecastDevelopmentChart.series[index].color = settingItem.value;
								}
							}
							if (settingItem.name.toLowerCase().includes("charttype")) {
								let ElementName = settingItem.name.toLowerCase();
								ElementName = ElementName.replace("charttype", "");
								if (ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() && settingItem.value != null && settingItem.value != "") {
									let chartTypes = settingItem.value.split('-');
									if (chartTypes.length > 0) {
										this.dxForecastDevelopmentChart.series[index].type = chartTypes[0];
									}
									if (chartTypes.length > 1) {
										this.dxForecastDevelopmentChart.series[index].dashStyle = chartTypes[1];
									}
								}
							}
						});
					}
				}
			}

				this.settingValueData = data.settingValue;
				data.settingValue.forEach(settingItem => {
					if (settingItem.name == "TopdownAdjustment" && settingItem.value != null && settingItem.value.toLocaleLowerCase() == "no") {
						this.topDownVisibility = false;
					}

					if (settingItem.name == "ForecastOverviewAltPeriodChartHeader" && settingItem.value != null) {
						this.alterGroupTitle = settingItem.value;
					}

					if (settingItem.name == "ForecastOverviewAltPeriodChartShow" && settingItem.value != null && settingItem.value == 'yes') {
						this.alterGrouphideShow = true;
					}

					//EnableNegativeForecast
					if (settingItem.name == "EnableNegativeForecast" && settingItem.value && settingItem.value == 'yes') {
						this.startChartValue = null;
					}

					//Enable Disable Forecast Seasonality
					if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityactual1")) {
						if (settingItem.value.toLowerCase() == "no") {
							this.EnableDisableForecastSeasonalityActual1 = false;
						}
					}
					if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityactual2")) {
						if (settingItem.value.toLowerCase() == "no") {
							this.EnableDisableForecastSeasonalityActual2 = false;
						}
					}
					if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityactual3")) {
						if (settingItem.value.toLowerCase() == "no") {
							this.EnableDisableForecastSeasonalityActual3 = false;
						}
					}
					if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalityforecastfinal3")) {
						if (settingItem.value.toLowerCase() == "no") {
							this.EnableDisableForecastSeasonalityForecastFinal3 = false;
						}
					}
					if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalitymin")) {
						if (settingItem.value.toLowerCase() == "no") {
							this.EnableDisableForecastSeasonalityMin = false;
						}
					}
					if (settingItem.name.toLowerCase().includes("enabledisableforecastseasonalitymax")) {
						if (settingItem.value.toLowerCase() == "no") {
							this.EnableDisableForecastSeasonalityMax = false;
						}
					}

				});

				if (data) {
					this.forecastDevelopmentChartSource = data.forecastDevelopmentChart;
					this.dxForecastDevelopmentChart.instance.hideLoadingIndicator();

					this.seasonalityChartDataSource = data.forecastSeasonalityChartPers;
					this.dxSeasonalityChart.instance.hideLoadingIndicator();

					this.yearOnYearChartDataSource = data.forecastYearOnYearChart;
					this.dxYearOnYearChart.instance.hideLoadingIndicator();

					//adding for year on year chart data need to be serials
					if (data.forecastYearOnYearChart != null) {
						data.forecastYearOnYearChart.forEach(EachItem => {
							if (EachItem != null) {
								this.yearOnYearChartDataSource.push({ DataName: 'RXY', DataValue: EachItem.rxy });
								this.yearOnYearChartDataSource.push({ DataName: 'FinalForecast3', DataValue: EachItem.finalForecast3 });
								this.yearOnYearChartDataSource.push({ DataName: 'ReleasedForecast', DataValue: EachItem.releasedForecast });
								this.yearOnYearChartDataSource.push({ DataName: 'Actual', DataValue: EachItem.actual });
							}
						});

						this.dxYearOnYearChart.instance.hideLoadingIndicator();
					}
				}
				else {
					//setting data to null if no data found
					this.forecastDevelopmentChartSource = [];
					this.yearOnYearChartDataSource = [];
					this.seasonalityChartDataSource = [];

					this.dxForecastDevelopmentChart.instance.hideLoadingIndicator();
					this.dxSeasonalityChart.instance.hideLoadingIndicator();
					this.dxYearOnYearChart.instance.hideLoadingIndicator();
				}

				if (action == 'topdownLoad') {
					this.dataGrid.instance.endCustomLoading();
				}
				this.alterGroupData = data.alterGroupData;

				this.onResize();
				this.LoadChartSeries();
			}).catch((err) => {
				console.log(err, "test error");
			});
		if (action != 'topdownLoad') {
			this.getOverviewTableData(action);
		}
	}

	getOverviewTableData(action) {
		if (this.dataGrid) { this.dataGrid.instance.beginCustomLoading('Loading...'); }
		const $this = this;

		let filters: FilterOutput[] = [];
		if (action == 'loadNextPreOption') {
			if (this.nxtPreFilterOptions != null && this.nxtPreFilterOptions.filters != null && this.nxtPreFilterOptions.filters.length > 0) {
				this.nxtPreFilterOptions.filters.forEach(selElemnt => {
					filters.push({
						settingId: selElemnt.settingId,
						fieldValue: selElemnt.fieldValue
					});
				});
			}
		}
		else {
			filters = this.filterOptions.filters;
		}
		let filtervalue: FilterValue[] = [];
		if (this.unsavedChanges == true) {
			this.changedFcTableRecords.forEach(element => {
				filtervalue.push({
					columnName: 'ForecastObjectClientId',
					value: element['ForecastObjectClientId']
				});
			})
		}
		this.forecastService.cancelPreviousRequests();
		this.forecastService.getOverviewTableData(this.Action, this.Unit, this.settingGroupId, this.UnitOfMeasure, filters, filtervalue).subscribe(result => {
			if (action == 'UpdateCommnet') {
				filtervalue.forEach(y => {
					let filterindex = result.data.findIndex(z => z.ForecastObjectClientId == y.value);
					if (filterindex == -1) {
						let findindex = this.tableValuesDataSource.findIndex(x => x.ForecastObjectClientId == y.value);
						this.tableValuesDataSource.splice(findindex, 1)
					}
				}
				)
				result.data.forEach(element => {
					let findindex = this.tableValuesDataSource.findIndex(x => x.ForecastObjectClientId == element.ForecastObjectClientId);
					if (findindex != -1) {
						this.tableValuesDataSource[findindex] = element;
					}
				})
			}
			else {
				$this.tableColumnsDataSource = [];
				$this.tableColumnsDataSource = [];
				if (result != null && result.columns != null) {
					for (let i = 0; i < result.columns.length; i++) {
						let dataTypeValue = "string";
						if (this.SettingDecimal != null && this.SettingDecimal.length > 0) {
							let itemFilter = this.SettingDecimal.find(x => x.name == result.columns[i].columnName);
							if (itemFilter != null) {
								dataTypeValue = "number";
							}
						}


						$this.tableColumnsDataSource.push({
							caption: result.columns[i].caption,
							columnName: result.columns[i].columnName,
							dataType: dataTypeValue
						})
					}
				}
				$this.tableValuesDataSource = result.data;
				setTimeout(() => {
					this.LoadChartSeries();
				}, 1000);
			}
			$this.dataGrid.instance.endCustomLoading();
		});

		this.forecastService.getIssueResponseDatasource().subscribe(result => {
			this.issueResponsesDataSource = result.map(x => x.listElement);
		});
	}

	//window resize function  refresh all charts
	onResize() {
		setTimeout(() => {
			this.dxForecastDevelopmentChart.instance.refresh();
			this.dxSeasonalityChart.instance.refresh();
			this.dxYearOnYearChart.instance.refresh();
			this.forecastDevelopmentRangSelct.instance.render();
			if (this.dxAlterGroupChart && this.dxAlterGroupChart.instance) { this.dxAlterGroupChart.instance.refresh(); }

		});
	}

	customizePointaltGroup = (arg: any) => {
		if (arg != null && arg.data != null && arg.data.name != null) {
			let dataFilter = this.settingValueData.filter(e => e.name == arg.data.name + 'Color');
			if (dataFilter != null && dataFilter.length > 0) {
				return { color: dataFilter[0].value, hoverStyle: { color: dataFilter[0].value } };
			}
		}

		return undefined;
	}

	//on search button click
	applyFilters() {
		if (this.currentValueNxtPr != null && this.currentValueNxtPr.columnName != null) {
			this.OnResetPreDieldChange(this.currentValueNxtPr.columnName);
		}
		if (this.changingValue != null) {
			this.changingValue.next(true);
		}
		this.currentValueNxtPr = null;
		this.clearSelectedItem();
		let currentFilters: FilterInput[] = [];
		let filters: FilterOutput[] = [];
		this.taskFilterData = [];
		if (this.filterList.filter(item => item.selectedValues).length > 0) {
			this.filterList.forEach(item => {
				if (item.selectedValues && item.selectedValues.length > 0) {

					const current = new FilterInput();
					current.selectionId = item.selectionId;
					current.selectedValues = item.selectedValues;
					currentFilters.push(current);

					item.selectedValues.forEach(el => {
						let f = new FilterOutput();
						f.settingId = item.selectionId;
						f.fieldValue = el;
						let taskF = new TaskDataFilter();
						taskF.settingId = item.selectionId;
						taskF.settingValue = el;
						this.taskFilterData.push(taskF);
						filters.push(f);
					})
				}
			}
			)
		}
		this.currentlySelectedFilters = currentFilters;

		this.filterOptions.filters = filters;
		this.shareDataService.CleanData();
		this.fillSharedItem();
		this.loadLengendToShare();
		this.getFiltersData();
		this.getData('reload');
	}

	fillSharedItem() {
		this.shareDataService.filterOptions = this.filterOptions;
	}
	//reseting filter data
	resetFilters() {
		this.taskFilterData = [];
		this.ChartSettings = null;
		this.changingValue.next(true);
		this.loadLengendToShare();
		this.filterOptions.filters = [];
		this.clearSelectedItem();
		this.filterList.map(item => item.selectedValues = []);
		this.IsTaskLoad = false;
		this.applyFilters();
		this.resetFiltersItems = [];
		this.currentlySelectedFilters = [];
	}

	//dynamic dropdown event to set values
	setDropDownFiltersOptins(filters: DropdowndSelectedValues) {
		this.filterList.forEach(item => {
			if (item.selectionId === filters.selectionId) {
				item.selectedValues = filters.values;
			}
		})
	}

	//#region Chart Settings and funcation
	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "Year-Month", "", "");
	}

	//adding customize setting with title, change title if need.
	customizeTooltipFc = (info: any) => {
		return DevTooltipCustComponent.customizeTooltipNew(info, "", "", "");
	}

	//adding percentage symbol in seasonality
	customizeText = (info: any) => {
		return Math.round(info.value).toLocaleString() + '%';
	}

	//adding customize Point color for seasonality chart only
	customizePoint = (arg: any) => {
		if (arg.argument != null) {
			if (arg.argument == 'FC') {
				return {
					visible: true,
					color: "#BE4B48"
				};
			}
		}

		return undefined;
	}

	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
			
		}
		this.loadLengendToShare();
	}
	loadLengendToShare() {
		let seriesValues = { ForecastDevelopmentChart: [], YearOnYearChart: [], SeasonalityChart: [], ScopeList: [] };
		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.instance != null
			&& this.dxForecastDevelopmentChart.instance.getAllSeries() != null) {
			this.dxForecastDevelopmentChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ForecastDevelopmentChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.instance != null
			&& this.dxYearOnYearChart.instance.getAllSeries() != null) {
			this.dxYearOnYearChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.YearOnYearChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.instance != null
			&& this.dxSeasonalityChart.instance.getAllSeries() != null) {
			this.dxSeasonalityChart.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.SeasonalityChart.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}
		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	//hide and show series on click
	onLegendClick(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}
	//#endregion

	setTextBoxFilterOptions(settingId: any, event: any) { }

	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPathDynamic(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-fc-overview', JSON.stringify(this.dataGrid.instance.state()));
	}

	gridRowUpdated(e) {
		this.unsavedChanges = true;
		this.changedFcTableRecords.push(e.data);
	}

	gridSelectionChanged(data: any) {
		this.selectedFcTableRecords = [];

		data.selectedRowKeys.forEach(element => {
			if (!this.selectedFcTableRecords.includes(element)) {
				this.selectedFcTableRecords.push(element);
			}
		});
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'topDownButtonTemplate'
		}, {
			location: 'before',
			template: 'saveButtonTemplate'
		}, {
			location: 'before',
			template: 'undoButtonTemplate'
		});
	}

	canEdit(item: any): boolean {
		const dataField = item.column.dataField;
		const correspondingColumn = this.tableColumnsDataSource.find(x => x.columnName === dataField);

		if (correspondingColumn && (correspondingColumn.columnName === 'PermanentComment' || correspondingColumn.columnName === 'IssueResponse')) {
			return true;
		}

		return false;
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}


	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	rowButtonClicked(e, data) {
		e.event.stopPropagation();


		window.open('forecast/deep-dive-new?id=' + UtilsService.getURLHelper(data.data.ForecastObjectClientId), '_blank');

	}

	saveAllChanges() {
		if (this.unsavedChanges) {

			this.forecastService.updateOverviewTableData(this.changedFcTableRecords).subscribe(() => {
				this.showInfoPopup = true;
				this.infoPopupMessage = 'Changes Saved Successfully!';
				this.infPopupTitle = 'Saved';

				this.getOverviewTableData('UpdateCommnet');
				this.unsavedChanges = false;
				this.changedFcTableRecords = [];
				setTimeout(() => {
					this.changeInfoPopupStatus();
				}, 3000);
			});
		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}

	undoAllChanges() {
		if (this.unsavedChanges) {

			this.changedFcTableRecords = [];
			this.getOverviewTableData("");
			this.unsavedChanges = false;

		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}

	deleteSelectedRecords() {

		this.forecastService.deleteOverviewTableData(this.selectedFcTableRecords).subscribe(() => {
			this.getOverviewTableData("");
			this.showInfoPopup = true;
			this.infoPopupMessage = 'Tasks deleted successfully!';
			this.infPopupTitle = 'Deleted';

			this.selectedFcTableRecords = [];

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		});
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = false;
		this.infoPopupMessage = '';
		this.infPopupTitle = '';
	}

	//topdwown
	selectedItemForecastElement = '';
	selectedItemUnitElement = 'BaseUnit';
	popupTopDownVisible = false;
	forecastAjstListData: any;
	forecastCaption: ForecastChartCaption[] = [];

	SaveTopdownEventloadchart(item: any) {
		this.getData('topdownLoad');
	}
	loadTopDownCharts() {
		this.forecastAjstListData = [];
		if (this.selectedFcTableRecords != null && this.selectedFcTableRecords.length > 0) {
			this.gotoTop();
			this.getData('topdownLoad');
		}
		else {
			this.tableValuesDataSource.forEach(element => {
				if (!this.selectedFcTableRecords.includes(element)) {
					this.selectedFcTableRecords.push(element);
				}
			});
			this.gotoTop();
			this.getData('topdownLoad');
		}
	}

	gotoTop() {
		let scrollElem = document.querySelector('#mainContentBox');
		scrollElem.scrollIntoView();
	}

	openPopupTopDown() {
		this.forecastAjstListData = [];
		if (this.selectedFcTableRecords != null && this.selectedFcTableRecords.length > 0) {
			this.popupTopDownVisible = true;
		}
		else {
			this.tableValuesDataSource.forEach(element => {
				if (!this.selectedFcTableRecords.includes(element)) {
					this.selectedFcTableRecords.push(element);
				}
			});
			this.popupTopDownVisible = true;
		}
	}

	topdownSearchData: TopdownAdjustmentParamNew = new TopdownAdjustmentParamNew();
	getSearchData(itmes: TopdownAddAdjustmentSelection) {

		this.topdownSearchData = new TopdownAdjustmentParamNew();
		this.topdownSearchData.forecastElemntName = itmes.forecastElemntNameValue;
		this.topdownSearchData.forecastUnitMeasure = itmes.forecastUnitMeasureValue;
		this.topdownSearchData.forecastSplitBase = itmes.forecastBaseSplitValue;
		this.topdownSearchData.forecastItem = [];
		this.selectedFcTableRecords.forEach(i => {
			this.topdownSearchData.forecastItem.push(
				{
					"id": i["ForecastObjectClientId"]
				});
		});

		let UnitOfMeasureName = this.UnitOfMeasure;
		let UnitOfMeasureData = this.filterList.filter(x => x.displayName == "UnitOfMeasure" || x.selectionName == "UnitOfMeasure");
		if (UnitOfMeasureData != null && UnitOfMeasureData.length > 0 && UnitOfMeasureData[0].selectedValues != null
			&& UnitOfMeasureData[0].selectedValues.length > 0) {
			UnitOfMeasureName = UnitOfMeasureData[0].selectedValues[0];
		}

		this.topdownSearchData.UnitOfMeasureName = UnitOfMeasureName;
		this.selectedItemUnitElement = this.topdownSearchData.UnitOfMeasureName;

		this.forecastService.getTopdownAdjustmentListDataSearchNew(
			this.topdownSearchData,
			{
				showLoadingIndicator: false,
			}
		).subscribe(
			{
				next: (response) => {
					response.forecastAdjustmentItem.forEach(element => {
						if (element.removeAjestValue == null || element.removeAjestValue == undefined) {
							element.removeAjestValue = false;
						}
					});

					this.forecastAjstListData = response.forecastAdjustmentItem;
					this.forecastCaption = response.forecastCaption;
				}
			}
		);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	clearSelectedItem() {
		this.selectedFcTableRecords = [];
		this.dataGrid.instance.clearSelection();
	}

	public onHelpButtonClicked(event, settingName: string) {
		this.helpService.openHelpPage(settingName);
	}

	
	/* Export Option */
	IsExportEnable = false;
	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportForecastOverview").subscribe(resultFilename => {
			this.IsExportEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});

		this.fileExportService.WebSettings("EnableExportForecastOverviewList").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() == "yes" ? true : false);
		}, err => {
			console.log(err);
		});
	}


	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	enableNextPrevious = false;
	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot("actionpivotTooltipForecastOverview").subscribe(result => {
			if (result != null && result.length > 0 && result[0].defaultSelectionTooltipForecastOverview != null
				&& result[0].defaultSelectionTooltipForecastOverview.toLowerCase() == "yes") {
				this.EnableTooltip = true;
			}
			if (result != null && result.length > 0 && result[0].enableDisableTooltipForecastOverview != null
				&& result[0].enableDisableTooltipForecastOverview.toLowerCase() == "yes") {
				this.ShowTooltip = true;
			}

			if (result != null && result.length > 0 && result[0].enableNextPreviousForecastOverview != null
				&& result[0].enableNextPreviousForecastOverview.toLowerCase() == "yes") {
				this.enableNextPrevious = true;
			}

		}, err => {
			console.log(err);
		});
	}

	alterWindows(e) {
		e.preventDefault();
		alert('tetst');
	}

	handleKeyUp(e) {
		if (e.keyCode === 13) {
			this.alterWindows(e);
		}
	}
	currentValueNxtPr: NextPreValue;
	OnResetPreDieldChange(e: string) {
		if (e != null) {
			let filterDataitem = this.filterList.find(x => x.selectionName == e);
			if (filterDataitem != null && filterDataitem.selectionId != null) {
				filterDataitem.selectedValues = [];
				this.taskFilterData = this.taskFilterData.filter(x => x.settingId != filterDataitem.selectionId);
				this.filterOptions.filters = this.filterOptions.filters.filter(x => x.settingId != filterDataitem.selectionId);
			}
		}
	}

	OnNextPreChange(e: NextPreValue) {
		this.currentValueNxtPr = e;
		if (!Number.isNaN(Number(e.selectionId))) {
			//default load with parameters
			this.nxtPreFilterOptions = new FiltersOutput();
			this.nxtPreFilterOptions.action = this.action;
			this.nxtPreFilterOptions.settingGroupId = this.settingGroupId;
			this.nxtPreFilterOptions.filters = [];
			//loading filter data
			if (this.taskFilterData == undefined) { this.taskFilterData = []; }
			this.taskFilterData = this.taskFilterData.filter(x => x.settingId !== Number(e.selectionId));
			this.filterOptions.filters = this.filterOptions.filters.filter(x => x.settingId !== Number(e.selectionId));
			this.taskFilterData.push({ settingId: Number(e.selectionId), settingValue: e.currentValue, fieldName: e.columnName });
			this.filterList.forEach(fcItem => {
				if (fcItem.selectionId === Number(e.selectionId)) {
					fcItem.selectedValues = [];
				}
			});

			if (this.filterList != null) {
				this.filterList.forEach(element => {
					if (element != null && element.selectedValues != null && element.selectedValues.length > 0
						&& Number(e.selectionId) != element.selectionId
					) {
						element.selectedValues.forEach(elementSelct => {
							let filteItemSel: FilterOutput = new FilterOutput();
							filteItemSel.fieldValue = elementSelct;
							filteItemSel.settingId = Number(element.selectionId);
							this.nxtPreFilterOptions.filters.push(filteItemSel);
						});
					}
				});
			}
			let filteItem: FilterOutput = new FilterOutput();
			filteItem.fieldValue = e.currentValue;
			filteItem.settingId = Number(e.selectionId);
			this.nxtPreFilterOptions.filters.push(filteItem);
			this.IsTaskLoad = true;
			this.getFiltersData();
			this.getData('loadNextPreOption');
		}
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();
	}

	onPopupShowing() {
		if (this.TopDownComp) {
			this.TopDownComp.searchData('');
		}
	}

	ngOnDestroy() {
		this.forecastService.cancelPreviousRequests();
	}
	filterMappingService = new FilterMappingService();
	ExportToExcelFilters: ExportFilter[] = [];
}
